

(function ($) {
    $(function () {

        var $toggle = $('.js-toggle-trigger');
        var $toggleOverlay = $('.toggle__overlay');
        $toggle.on('click', viewMore);
        $toggleOverlay.on('click', viewMore);

        function viewMore() {
            $(this).toggleClass('is-active');
            $('.js-toggle').toggleClass('is-opened');
        }

        var $modal = $('.js-modal-trigger');
        var $modalClose = $('.js-modal-close');
        var $modalOverlay = $('.modal__overlay');

        $modal.on('click', openModal);
        $modalClose.on('click', openModal);
        $modalOverlay.on('click', openModal);

        function openModal() {
            $(this).toggleClass('is-active');
            $('.js-modal').toggleClass('is-opened');
        }

        // Show signup on first page visit
        function showMessage() {
            setTimeout(function(){
                $('.modal--message').addClass('is-opened');
            }, 5000);
        }

        if (!Cookies.get('showAnnouncement')) {
            Cookies.set('showAnnouncement', true, {
              expires: 2
            });
            showMessage();
        }

        // Filters
        var $filtersToggle = $('.js-filters-trigger');

        $filtersToggle.on('click', openFilters);

        function openFilters() {
            $(this).toggleClass('is-active');
            $('.js-filters').toggleClass('is-open');
        }

        // Accordion
        var $accordionTrigger = $('.accordion__trigger');

        $accordionTrigger.on('click', openAccordion);

        function openAccordion() {
            var $this = $(this),
                $accordionItem = $this.closest('.accordion'),
                $accordionItems = $('.accordion'),
                $hasClass = $accordionItem.hasClass('is-active');

            if ( $hasClass ) {
                $accordionItem.removeClass('is-active');
            }
            else {
                $accordionItems.each(function () {
                    $accordionItems.removeClass('is-active');
                });

                $accordionItem.addClass('is-active');
            }
        }
    });
})(jQuery);
